import React, { useState } from "react";
import StudentSidebar from "../components/studentsidebar";
import Navbar from "../components/studentnavbar";
import { useSidebar } from '../components/SidebarContext';

const StudentMark = () => { const { isSidebarOpen } = useSidebar();
 const sidebarWidth = isSidebarOpen ? '15.6rem' : '4.4rem';
  // Define sidebar width
  
  const [collapsed, setCollapsed] = useState(false);
  
  // Adjust sidebar width based on collapsed state
  const currentSidebarWidth = collapsed ? '80px' : sidebarWidth;

  // Sample data for the dashboard
  const stats = {
    testsCompleted: 12,
    upcomingTests: 3,
    averageScore: 85,
    highestScore: 98,
  };

  const recentTests = [
    { id: 1, name: "Mathematics Quiz", date: "2023-05-01", score: 92, total: 100 },
    { id: 2, name: "Science Assessment", date: "2023-04-28", score: 88, total: 100 },
    { id: 3, name: "English Grammar Test", date: "2023-04-23", score: 78, total: 100 },
  ];

  // Function to toggle sidebar collapsed state
  const toggleSidebar = () => {
    setCollapsed(!collapsed);
  };

  return (
    <div style={{ minHeight: "100vh", backgroundColor: "#f0f4f8", display: "flex", flexDirection: "column" }}>
      {/* Navbar - fixed at top */}
      <div style={{ position: "fixed", top: 0, left: 0, right: 0, zIndex: 20 }}>
        <Navbar />
      </div>

      <div style={{ display: "flex", marginTop: "55px", minHeight: "calc(100vh - 55px)" }}>
        {/* Sidebar - fixed at left */}
        <div style={{ 
          position: "fixed", 
          top: "55px", 
          left: 0, 
          height: "calc(100% - 55px)", 
          width: currentSidebarWidth, 
          zIndex: 10,
          transition: 'width 0.3s ease' 
        }}>
          <StudentSidebar collapsed={collapsed} onCollapse={toggleSidebar} />
        </div>

        {/* Main Content */}
        <div style={{ 
          marginLeft:  sidebarWidth, 
          width: `calc(100% - ${sidebarWidth})`,
          transition: 'all 0.3s ease',
          padding: "20px"
        }}>
          <div className="container">
            {/* Dashboard Stats */}
            <div className="row mb-4">
              <div className="col-12">
                <h2 className="mb-4">Student Test Dashboard</h2>
              </div>

              <div className="col-md-3">
                <div className="card bg-primary text-white">
                  <div className="card-body">
                    <h5 className="card-title">Tests Completed</h5>
                    <h2 className="card-text">{stats.testsCompleted}</h2>
                  </div>
                </div>
              </div>

              <div className="col-md-3">
                <div className="card bg-warning text-white">
                  <div className="card-body">
                    <h5 className="card-title">Upcoming Tests</h5>
                    <h2 className="card-text">{stats.upcomingTests}</h2>
                  </div>
                </div>
              </div>

              <div className="col-md-3">
                <div className="card bg-success text-white">
                  <div className="card-body">
                    <h5 className="card-title">Average Score</h5>
                    <h2 className="card-text">{stats.averageScore}%</h2>
                  </div>
                </div>
              </div>

              <div className="col-md-3">
                <div className="card bg-info text-white">
                  <div className="card-body">
                    <h5 className="card-title">Highest Score</h5>
                    <h2 className="card-text">{stats.highestScore}%</h2>
                  </div>
                </div>
              </div>
            </div>

            {/* Recent Test Results */}
            <div className="row mb-4">
              <div className="col-12">
                <div className="card">
                  <div className="card-header d-flex justify-content-between align-items-center">
                    <h4 className="mb-0">Recent Test Results</h4>
                    <button className="btn btn-sm btn-outline-primary">View All</button>
                  </div>
                  <div className="card-body">
                    <div className="table-responsive">
                      <table className="table table-hover">
                        <thead>
                          <tr>
                            <th>Test Name</th>
                            <th>Date</th>
                            <th>Score</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {recentTests.map((test) => (
                            <tr key={test.id}>
                              <td>{test.name}</td>
                              <td>{new Date(test.date).toLocaleDateString()}</td>
                              <td>
                                <div className="progress" style={{ height: "20px" }}>
                                  <div
                                    className={`progress-bar ${
                                      test.score >= 80
                                        ? "bg-success"
                                        : test.score >= 60
                                        ? "bg-warning"
                                        : "bg-danger"
                                    }`}
                                    role="progressbar"
                                    style={{ width: `${test.score}%` }}
                                    aria-valuenow={test.score}
                                    aria-valuemin="0"
                                    aria-valuemax="100"
                                  >
                                    {test.score}%
                                  </div>
                                </div>
                              </td>
                              <td>
                                <button className="btn btn-sm btn-info me-2">View</button>
                                <button className="btn btn-sm btn-secondary">Export</button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StudentMark;